<template>
	<v-dialog v-model="dialog" max-width="700px">
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				icon
				fab
				absolute
				right
				outlined
				color="secondary"
				small
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<slot name="icon">
					<v-icon>mdi-pencil</v-icon>
				</slot>
			</v-btn>
		</template>

		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white"> テンプレート名変更 </v-app-bar-title>
				<v-spacer />
				<v-btn v-if="$vuetify.breakpoint.xs" @click="dialog = false" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-card-text class="pa-2" color="black">
        <v-form ref="form" lazy-validation>
				<v-text-field
					v-model="name"
					type="text"
					class="ma-1 mt-4"
					label="テンプレート名"
					:rules="[rules.required]"
					outlined
					dense
				/>
        </v-form>
			</v-card-text>
			<v-card-actions>
				<v-row class="ma-0 pa-0" justify="center">
					<v-spacer></v-spacer>
					<v-btn class="ma-1" @click="submitForm" dense dark color="primary">変更する</v-btn>
					<v-spacer></v-spacer>
					<v-btn v-if="!$vuetify.breakpoint.xs" color="grey darken-1" text @click="dialog = false">
						キャンセル
					</v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import rules from "../../../helper/rules"

export default {
	props: {
		templateData: {
			type: Object,
			required: true,
			default: {
				id: {
					type: Number,
					default: null,
					required: true,
				},
				name: {
					type: String,
					default: null,
					required: true,
				},
			},
		},
	},
	data() {
		return {
			department_id: this.$route.params.department_id,
			rules: rules,
			dialog: false,
      name: null,
		}
	},
  mounted(){
    this.name = this.templateData.name
  },
	methods: {
		submitForm() {
			if (!this.$refs.form.validate()) return
			const headers = authenticate.setHeader()
			const url = `/erp/v1/departments/${this.department_id}/daily_report_templates/${this.template.id}`
			axios
				.patch(url, { daily_report_template:{name: this.name} }, { headers })
				.then((res) => {
					this.$emit("update-template", res.data.template)
					this.$refs.form.reset()
					this.$store.dispatch("setFlash", {
						text: "日報テンプレート名を変更しました。",
						type: "notice",
					})
          this.dialog = false
				})
				.catch((err) => {
					const error = errorHandling.errorResponse(err)
					if (Array.isArray(error)) {
						this.errors = error
					}
				})
		},
		closeDialog() {
		},
	},
	computed: {
		template: {
			get() {
				return this.templateData
			},
			set(newValue) {
				return this.$emit("update:template", newValue)
			},
		},
	},
}
</script>